.loadingSpinner {
  display: flex;
  justify-content: center;
  align-items: center;
  --loading-spinner-solid-filter: var(--spinner-filter);
  --loading-spinner-track: var(--color-progress-track);
  --loading-spinner-head: var(--spinner-head-color);
  --loading-spinner-gradient-start: var(--spinner-gradient-start);
  --loading-spinner-gradient-mid: color-mix(
    in srgb,
    var(--loading-spinner-gradient-start) var(--spinner-gradient-mid-pct),
    transparent
  );
  --loading-spinner-gradient-end: color-mix(
    in srgb,
    var(--loading-spinner-gradient-start) var(--spinner-gradient-end-pct),
    transparent
  );
  --loading-spinner-gradient-trail: color-mix(
    in srgb,
    var(--loading-spinner-gradient-start) var(--spinner-trail-pct),
    transparent
  );
  --spinner-stroke: 3px;
  .svgSpinnerContainer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .spinnerRing {
    position: relative;
    display: block;
    border-radius: 50%;
    transform-origin: center;
    animation-name: rotate;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-duration: var(--spinner-animation-duration, 1000ms);
    &::before,
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 50%;
    }
    &::before {
      border: var(--spinner-stroke) solid var(--loading-spinner-track);
    }
    &::after {
      -webkit-mask: radial-gradient(
        farthest-side,
        transparent calc(100% - var(--spinner-stroke)),
        var(--color-neutral-black) calc(100% - var(--spinner-stroke))
      );
      mask: radial-gradient(
        farthest-side,
        transparent calc(100% - var(--spinner-stroke)),
        var(--color-neutral-black) calc(100% - var(--spinner-stroke))
      );
    }
  }
  .solidRing {
    background-image: url('../../../assets/loadingSpinners/spinner.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    filter: var(--loading-spinner-solid-filter);
    &::before,
    &::after {
      display: none;
    }
    &::after {
      background: conic-gradient(
        from -90deg,
        var(--loading-spinner-head) 0deg 74deg,
        transparent 74deg 360deg
      );
    }
  }
  .gradientRing {
    background-image: var(--gradient-ring-image);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &::before,
    &::after {
      display: none;
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  &.spinner {
  }
  &.gradient {
  }
  &.xLarge {
    width: 80px;
    height: 80px;
    --spinner-stroke: 6px;
  }
  &.large {
    width: 48px;
    height: 48px;
    --spinner-stroke: 4px;
  }
  &.medium {
    width: 24px;
    height: 24px;
    --spinner-stroke: 3px;
  }
  &.small {
    width: 16px;
    height: 16px;
    --spinner-stroke: 2px;
  }
  @media (prefers-reduced-motion: reduce) {
    .spinnerRing {
      animation: none;
    }
  }
}
